import React, { useContext } from 'react'
import { createBrowserRouter, RouterProvider } from 'react-router-dom'

import * as Sentry from '@sentry/react'
import { useTheme } from 'styled-components/native'

import ContentLayout from '@lyrahealth-inc/ui-core/lib/molecules/layouts/base/ContentLayout'
import RootLayout from '@lyrahealth-inc/ui-core/lib/molecules/layouts/base/RootLayout'
import { ProductTypeContext } from '@lyrahealth-inc/ui-core-crossplatform/src/utils/productType/productTypeContext'
import { ThemeType } from '@lyrahealth-inc/ui-core-crossplatform/src/utils/themes/ThemeProvider'
import { ThemeScope } from '@lyrahealth-inc/ui-core-crossplatform/src/utils/themes/ThemeScope'

import MicrositeAndElsewhereTopBanner from '../../../features/microsite/components/Banners/MicrositeAndElsewhereTopBanner'
import ComingSoonMicrositeHomeContainer from '../../../features/microsite/components/comingSoonContainer/ComingSoonMicrositeHomeContainer'
import LyraSelectComingSoonMicrositeHomeContainer from '../../../features/microsite/components/comingSoonContainer/LyraSelectComingSoonMicrositeHomeContainer'
import MicrositeIntlProvider from '../../../features/microsite/MicrositeIntlProvider'
import Header from '../header/Header'
import ToastContainer from '../toastContainer/ToastContainer'

const HeaderWithScopedTheme = () => {
  const { isAuroraTheme, isDarkMode, colors } = useTheme() as ThemeType
  const logoColor = isAuroraTheme ? (isDarkMode ? colors.textPrimary : colors.textInverse) : undefined
  return <Header logoFillColor={logoColor} />
}

const ComingSoon = () => {
  const { isLyraSelect } = useContext(ProductTypeContext)
  const ComingSoonHomepage = (
    <MicrositeIntlProvider>
      <MicrositeAndElsewhereTopBanner />
      <ThemeScope forceDarkMode>
        <HeaderWithScopedTheme />
      </ThemeScope>
      <ToastContainer />
      <ContentLayout>
        {isLyraSelect ? <LyraSelectComingSoonMicrositeHomeContainer /> : <ComingSoonMicrositeHomeContainer />}
      </ContentLayout>
    </MicrositeIntlProvider>
  )

  const sentryCreateBrowserRouter = Sentry.wrapCreateBrowserRouterV6(createBrowserRouter)
  const router = sentryCreateBrowserRouter([
    {
      path: '*',
      index: true,
      element: ComingSoonHomepage,
    },
  ])

  return (
    <RootLayout>
      <RouterProvider router={router} />
    </RootLayout>
  )
}

export default ComingSoon
